import * as React from 'react';
import * as O from 'fp-ts/Option';
import * as R from 'fp-ts/Record';
import { pipe } from 'fp-ts/lib/function';
import { AvailabilityStatus } from '../generated/graphql';

interface Props {
  status: AvailabilityStatus | undefined;
  className?: string;
}

export const availabilityProps: Record<AvailabilityStatus, [string, string]> = {
  AVAILABLE: ['bg-green-500', 'Available'],
  UNAVAILABLE: ['bg-red', 'Unavailable'],
  MAYBE: ['bg-amber-500', 'Maybe available'],
  UNDECLARED: ['bg-grey-400', 'Not responded'],
};

export const getAvailabilityProps = (status: AvailabilityStatus) =>
  R.lookup(status, availabilityProps);

export const AvailabilityStatusDot: React.FC<Props> = ({
  status,
  className = '',
}) => {
  return pipe(
    status,
    O.fromNullable,
    O.chain((s) => R.lookup(s, availabilityProps)),
    O.map(([textClass, text]) => (
      <span
        key={text}
        className={`${textClass} inline-block w-2 h-2 rounded-full ${className}`}
        title={text}
      ></span>
    )),
    O.toNullable,
  );
};
